import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "@/contexts/StoreContext";
import { getProductPath } from "@/lib/api";
import { Trash2 } from "lucide-react";

const Wishlist = () => {
    const { wishlist, toggleWishlist } = useStore();

    return (
        <div data-testid="wishlist-page">
            <section className="px-4 md:px-8 py-10 md:py-16 border-b-4 border-ink">
                <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-hazard">
                    [Saved Pieces]
                </span>
                <h1 className="font-heading text-6xl md:text-8xl uppercase leading-[0.85] mt-2">
                    Wishlist
                </h1>
                <p className="mt-2 font-mono-ui text-xs uppercase tracking-[0.2em] text-muted-foreground">
                    {wishlist.length} piece{wishlist.length === 1 ? "" : "s"} saved
                </p>
            </section>

            {wishlist.length === 0 ? (
                <section className="px-4 md:px-8 py-24 text-center border-b-4 border-ink">
                    <p className="font-heading text-5xl uppercase">Nothing saved yet.</p>
                    <p className="mt-3 font-mono-ui text-xs uppercase tracking-[0.2em] text-muted-foreground">
                        Heart something. Build the rotation.
                    </p>
                    <Link
                        to="/shop"
                        className="inline-block mt-8 bg-ink text-black border-2 border-ink px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.25em] hover:bg-hazard hover:border-hazard"
                        data-testid="wishlist-shop-button"
                    >
                        Browse The Drop
                    </Link>
                </section>
            ) : (
                <section
                    className="grid grid-cols-2 lg:grid-cols-4 border-b-4 border-ink"
                    data-testid="wishlist-grid"
                >
                    {wishlist.map((item, idx) => (
                        <div
                            key={item.id}
                            className={`relative border-ink ${
                                idx % 2 === 1 ? "border-l-2" : ""
                            } ${idx % 4 !== 3 ? "lg:border-r-2" : ""} border-t-2`}
                        >
                            <Link
                                to={getProductPath(item)}
                                className="block aspect-[4/5] bg-bone overflow-hidden"
                                data-testid={`wishlist-item-${item.id}`}
                            >
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                />
                            </Link>
                            <div className="p-4 border-t-2 border-ink flex justify-between items-center">
                                <div className="min-w-0">
                                    <Link
                                        to={getProductPath(item)}
                                        className="block font-heading text-xl uppercase truncate hover:text-hazard"
                                    >
                                        {item.name}
                                    </Link>
                                    <span className="font-mono-ui text-xs">
                                        ${item.price.toFixed(0)}
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => toggleWishlist(item)}
                                    aria-label="Remove from wishlist"
                                    className="border-2 border-ink p-2 hover:bg-hazard hover:border-hazard hover:text-black"
                                    data-testid={`wishlist-remove-${item.id}`}
                                >
                                    <Trash2 className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    ))}
                </section>
            )}
        </div>
    );
};

export default Wishlist;
